module.exports = __webpack_public_path__ + "img/camcorder.e8318df3.svg";